import PropTypes from 'prop-types';
import classNames from 'classnames';

import Checkbox from '../Checkbox';

import Badge from '../Badge';

import styles from './CheckboxWithLabel.module.scss';

const CheckboxWithLabel = ({
  className = '',
  text = '',
  showCount = false,
  count = null,
  checked,
  labelTitle = null,
  ...rest
}) => {
  const countComponent =
    showCount && !checked ? (
      <Badge label={count} theme="secondary-pink-light" size="tiny" />
    ) : null;

  return (
    <div className={classNames(styles.checkboxWithLabel, className)}>
      <Checkbox checked={checked} {...rest} />
      {rest.id ? (
        <label htmlFor={rest.id} className={styles.text}>
          {labelTitle && (
            <>
              <span className={styles.title}>{labelTitle}</span>
              <span> - </span>
            </>
          )}
          {text && <span>{text}</span>}
          {countComponent}
        </label>
      ) : (
        <span className={styles.text}>
          {text} {countComponent}
        </span>
      )}
    </div>
  );
};

CheckboxWithLabel.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  labelTitle: PropTypes.string,
  showCount: PropTypes.bool,
  count: PropTypes.number,
  ...Checkbox.propTypes
};

export default CheckboxWithLabel;
